import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomMoldedRubberGasketProductsComponent } from './custom-molded-rubber-gasket-products.component';

const routes: Routes = [
  {
    path: '',
    component: CustomMoldedRubberGasketProductsComponent,
    data: {
      meta: {
        title: 'Custom Molded Rubber and Gasket Index | Marco Sealing Solutions',
        description: 'Custom Molded Rubber and Gasket Seals Product Index from Marco Sealing Solutions (formerly Marco Rubber & Plastics)',
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class CustomMoldedRubberGasketProductsRoutingModule { }
